export var USE_GENERAL_AI_KNOWLEDGE = 'use-general-ai-knowledge';
export var USE_ROVO_ORGANISATION_KNOWLEDGE = 'use-rovo-organisation-knowledge';
export var TELL_AI = 'tell-ai';
export var TELL_AGENT = 'tell-agent';
export var BROWSE_AGENTS = 'agent:browse-more-agents';
export var SHOW_MORE = 'show-more';
export var UI_SCROLL_MARGIN_TOP = 32;